import React, { useState, useEffect, useRef } from "react";
import {
    Form,
    Input,
    Label,
    Segment,
    Button,
    Icon,
    Popup,
} from "semantic-ui-react";
import {
    Live,
    Rates,
    Hotels,
    RoomTypes,
    AllocationAndStrategy,
    Customers,
    Promotions,
    Addons,
} from "../../api/services/next";
import { DatePicker } from "../../components/shared/DatePicker";
import HotelsDropDown from "../../components/shared/HotelsDropDown";
import { useTextResources } from "../../language";
import GridSearchTemplate from "../GridSearchTemplate";
import moment from "moment";
import _ from "lodash";
import cn from "classnames";
import { isMobileOnly } from "mobile-device-detect";
import RoomTypesDropDown from "../../components/shared/RoomTypesDropDown";
import RatesDropDown from "../../components/shared/RatesDropDown";
import CustomerDropDown from "../../components/shared/CustomerDropDown";
import { Currencies } from "../../components/shared/currencies";
import { useCurrentHotel } from "../../hooks/useCurrentHotel";
import { AllocationDatesPopup } from "../../components/AllocationAndStrategy/AllocationDatesPopup";
import {
    HotelFeatureCodes,
    dateFormatWithDayInitials,
    RateCategory,
    RestrictionTypes,
    LevelValues,
    OverrideCustomerRestrictionsCustomerId,
    Actions,
} from "../../components/shared/constants";
import YieldPopup from "../../components/YieldPopup";
import { getLastCustomerRestriction } from "./getLastCustomerRestriction";
import RestrictionsPopup from "../../components/RestrictionsPopup";
import RemoveManualRestrictionsPopup from "../../components/RemoveManualRestrictionsPopup";
import AllocationsDropDown from "../../components/shared/AllocationsDropDown";
import {
    groupBy,
    roundToPrecision,
} from "../../components/shared/utils";
import PriceUpdatePopup from "../../components/PriceUpdatePopup";
import "./style.css";
import {
    LeftChevronButton,
    RightChevronButton,
} from "../../components/shared/icons";
import CheckboxWrapper from "../../components/shared/Checkbox";
import { OverbookingCreationPopup } from "../OverBooking/OverbookingCreationPopup";
import { useLoader } from "../../hooks/useLoader";
import PromotionsDropDown from "../../components/shared/PromotionsDropDown";

export const LivePage = () => {
    const loader = useLoader();
    const text = useTextResources();
    const currentHotel = useCurrentHotel();
    const levels = ["HotelName", "RoomTypeName", "RateName", "ProductName"];
    const levelIds = ["HotelId", "RoomTypeId", "RateId", "ProductStringId"];
    const titles = [text("Hotel"), text("RoomType"), text("Rate")];
    const days = 10;
    const restrictionTypesValues = {
        1: { value: "C", color: "red" },
        2: { value: "A", color: "yellow" },
        3: { value: "D", color: "blue" },
        4: { value: "AD", color: "teal" },
        5: { value: "O", color: "green" },
        6: { value: "DC", color: "orange" },
    };

    const allocationFeatureEnabled =
        currentHotel?.HotelFeatures?.find(
            (hf) => hf.FeatureID == HotelFeatureCodes.Allocations
        ) !== null;

    const [search, setSearch] = useState({
        FromDate: moment().startOf("day").toDate(),
        ToDate: moment(moment().toDate()).add(days, "days").toDate(),
        ConsiderOverbooking: true,
    });
    const [showDatesPopup, setShowDatesPopup] = useState(false);
    const [showYieldPopup, setShowYieldPopup] = useState(false);
    const [showRestrictionsPopup, setShowRestrictionsPopup] = useState(false);
    const [showRemoveManualRestrictionsPopup, setShowRemoveManualRestrictionsPopup] = useState(false);
    const [hotels, setHotels] = useState([]);
    const [roomTypes, setRoomTypes] = useState([]);
    const [rates, setRates] = useState([]);
    const [promotions, setPromotions] = useState([]);
    const [allocations, setAllocations] = useState([]);
    const [showAllocationsData, setShowAllocationsData] = useState(false);
    const [data, setData] = useState([]);
    const [availabilityData, setAvailabilityData] = useState([]);
    const [showPriceUpdatePopup, setShowPriceUpdatePopup] = useState(false);
    const [showOverbookingPopup, setShowOverbookingPopup] = useState(false);
    const [fromDate, setFromDate] = useState(moment().toDate());
    const [markManualUpdates, setMarkManualUpdates] = useState(false);
    const [customerId, setCustomerId] = useState();
    const [customers, setCustomers] = useState([]);
    const [expandedRowIds, setExpandedRowIds] = useState([]);
    const [showPaxOccupancy, setShowPaxOccupancy] = useState(false);
    const [addons, setAddons] = useState([]);
    const canRemoveRestrictions = window.optima.user?.ActionIDs?.includes(Actions.RemoveManualRestrictions) ?? false;

    const doSearch = useRef();

    const onSearchChange = (spec) => {
        if (!spec.PricingOnly) {
            const adjustedState = {
                ...spec,
                ToDate: moment(spec.FromDate).add(days, "days").toDate().toISOString()
            };
            setSearch(adjustedState);
        }
    };

    const onSearchComplete = (data, spec) => {
        if (spec.PricingOnly) {
            setData(prev => {
                const newData = [...prev];
                data.products.forEach(product => {
                    const index = newData.findIndex(item =>
                        item.PromotionId
                            ? item.PromotionId === product.PromotionId && item.BaseProductId === product.BaseProductId
                            : item.Id === product.Id
                    );
                    if (index !== -1) {
                        newData[index].Priced = product.Priced;
                        newData[index].Dates?.forEach(date => {
                            const productDate = product.Dates?.find(d => d.Date === date.Date);
                            date.SinglePrice = productDate?.SinglePrice;
                            date.DoublePrice = productDate?.DoublePrice;
                            date.IsManualOrRMS = productDate?.IsManualOrRMS;
                            date.PartiallyPriced = productDate?.PartiallyPriced;
                            date.AllowExternalUpdate = productDate?.AllowExternalUpdate;
                        });
                    }
                });
                return newData;
            })
        } else {
            setFromDate(spec.FromDate);
            setSearch(spec)
            setShowAllocationsData(
                data.products?.find((x) => x.Dates.find((d) => d.Allocation)) != null
            );
            setData(data.products);
            setAvailabilityData(data.availability);
            updateProductPricing(expandedRowIds, true)
        }
    };

    const menu = [
        {
            text: "YieldUpdate",
            className: "icon-calculator",
            onclick: () => {
                setShowYieldPopup(true);
            },
            disabled: false,
        },
        {
            text: "RestrictionPopup",
            className: "icon-do-not-disturbe",
            onclick: () => {
                setShowRestrictionsPopup(true);
            },
            disabled: false,
        },
        {
            text: "PricePopup",
            className: "icon-price-tag",
            onclick: () => {
                setShowPriceUpdatePopup(true);
            },
            disabled: false,
        },
        {
            text: "Overbooking",
            className: "icon-notebook-5",
            onclick: () => {
                setShowOverbookingPopup(true);
            },
            disabled: false,
        }
    ];

    if (canRemoveRestrictions) {
        menu.splice(1, 0, {
            text: "RemoveManualRestrictions",
            className: "trash alternate outline",
            onclick: () => {
                setShowRemoveManualRestrictionsPopup(true);
            },
            disabled: false
        });
    }

    if (allocationFeatureEnabled) {
        menu.push({
            text: "EditAllocationDates",
            className: "icon-calendarnumber",
            onclick: () => {
                setShowDatesPopup(true);
            },
            disabled: false,
        });
    }

    const date_x = (x) =>
        moment(fromDate).add(x, "days").format(dateFormatWithDayInitials);

    useEffect(() => {
        (async () => {
            loader(true);
            const hotels = await Hotels.GetHotels();
            setHotels(hotels);
            const customers = await Customers.GetCustomers();
            setCustomers(customers);
            loader(false);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            if (search.HotelIds?.length) {
                const addonsData = await Addons.GetHotelChainAddons({
                    HotelIds: search.HotelIds,
                    includes: ["RoomTypeAddons"]
                });
                setAddons(addonsData);
            } else {
                setAddons([]);
            }
        })();
    }, [search.HotelIds]);

    useEffect(() => {
        (async () => {
            if (search.HotelIds?.length) {
                const roomtypes = await RoomTypes.GetRoomTypes({
                    HotelIds: search.HotelIds,
                    FromDate: null,
                    EndDate: null,
                });
                setRoomTypes(roomtypes);
            } else clearDropDownsData();
        })();
    }, [search.HotelIds]);

    useEffect(() => {
        (async () => {
            if (search.HotelIds?.length) {
                const rates = await Rates.GetRates({
                    HotelIds: search.HotelIds,
                    IsActive: true,
                    InheritedRates: true,
                    FromDate: moment(search.FromDate).toISOString(),
                    ToDate: moment(search.ToDate).toISOString(),
                    RoomTypeIds: search.RoomTypeIds,
                    ExcludeRateCategoryIDs: [RateCategory.ExtraAddOn],
                });
                setRates(rates);
            } else clearDropDownsData();
        })();
    }, [search.RoomTypeIds, search.HotelIds, search.FromDate, search.ToDate]);

    useEffect(() => {
        (async () => {
            if (search.HotelIds?.length) {
                const promotionsData = await Promotions.GetPromotions({
                    HotelIds: search.HotelIds,
                    FromDate: moment(search.FromDate).toISOString(),
                    ToDate: moment(search.ToDate).toISOString(),
                    RateIds: search.RateIds,
                    RoomTypeIds: search.RoomTypeIds,
                });
                setPromotions(promotionsData);
            } else clearDropDownsData();
        })();
    }, [search.HotelIds, search.RoomTypeIds, search.RateIds, search.FromDate, search.ToDate]);

    useEffect(() => {
        (async () => {
            if (search.HotelIds?.length) {
                const allocations = await AllocationAndStrategy.GetAllocations({
                    IsStrategy: false,
                    GetHeadersOnly: true,
                    HotelIds: search.HotelIds,
                    RoomTypeIds: search.RoomTypeIds,
                    RateIds: search.RateIds,
                    PromotionIds: search.PromotionIds,
                    CustomerIds: search.CustomerId ? [search.CustomerId] : [],
                    IncludeHotelLevelWhenSuppliedRoomTypeIds: true,
                    FromDate: moment(search.FromDate).toISOString(),
                    ToDate: moment(search.ToDate).toISOString(),
                });
                setAllocations(
                    allocations.length ? [{ Id: -1, Name: "All" }, ...allocations] : []
                );
            } else clearDropDownsData();
        })();
    }, [search.HotelIds, search.RoomTypeIds, search.RateIds, search.PromotionIds, search.CustomerId, search.FromDate, search.ToDate]);

    const clearDropDownsData = () => {
        setRoomTypes([]);
        setRates([]);
        setPromotions([]);
        setAllocations([]);
    };

    const allocationsDataTooltip = (value) => {
        // Calculate ReleaseDate at runtime
        const releaseDate = value?.ReleaseDays && value?.Date 
            ? moment(value.Date).subtract(value.ReleaseDays, 'days').format('DD/MM/YYYY')
            : null;
        
        return (
            <p style={{ padding: "10px" }}>
                <div> {`${text("Allocated")}: ${value?.AllocatedRooms || 0}`}</div>
                <div> {`${text("Used")}: ${value?.UsedRooms || 0}`}</div>
                <div> {`${text("Left")}: ${value?.LeftRooms || 0}`}</div>
                <div>
                    {" "}
                    {`${text("PresentedForSale")}: ${value?.PresentedForSale || 0}`}
                </div>
                {releaseDate && (
                    <div> {`${text("ReleaseDate")}: ${releaseDate}`}</div>
                )}
            </p>
        );
    };

    const AllocationDataPopup = React.memo(({ value }) => {
        return (
            <Popup
                content={allocationsDataTooltip(value)}
                trigger={
                    <Label attached="bottom" basic>
                        {`${text("LiveAllocationsFormat")}: ${value?.AllocatedRooms || 0
                            }/${value?.UsedRooms || 0}/${value?.LeftRooms || 0}`}
                    </Label>
                }
            />
        );
    });

    const roomTypeOverbookingTooltip = (value) => {
        return (
            <p style={{ padding: '10px' }}>
                <div> {`${text('OB')}: ${value?.MaxOverbookedRoomQuantity || 0}`}</div>
                <div> {`${text('ActualAvailability')}: ${value?.AvailabilityConsideringOverbooking || 0}`}</div>
            </p>
        );
    };

    const restrictionMinDaysTooltip = (value) => {
        return value.MaxMinDaysRestrictionTooltipValue ===
            value.MinMinDaysRestrictionTooltipValue
            ? value.MinMinDaysRestrictionTooltipValue
            : `${value.MinMinDaysRestrictionTooltipValue}-${value.MaxMinDaysRestrictionTooltipValue}`;
    };

    const restrictionMaxDaysTooltip = (value) => {
        return value.MaxMaxDaysRestrictionTooltipValue ===
            value.MinMaxDaysRestrictionTooltipValue
            ? value.MinMaxDaysRestrictionTooltipValue
            : `${value.MinMaxDaysRestrictionTooltipValue}-${value.MaxMaxDaysRestrictionTooltipValue}`;
    };

    const hotelOverbookingTooltip = (value) => {
        return (
            <p style={{ padding: "10px" }}>
                <div>
                    {" "}
                    {`${text("HotelLevelOverbooking")}: ${value?.HotelLevelOverbooking || 0
                        }`}
                </div>
            </p>
        );
    };

    const RestrictionTypeLabel = (value) => {
        return (
            <Label
                attached="top right"
                corner
                size="mini"
                color={restrictionTypesValues[value?.RestrictionTypeId]?.color}
                style={{ fontWeight: "bold" }}
            >
                {value?.IsLowerLevelRestrictionTypeDifferent ? (
                    <div
                        className={cn({
                            isLowerLevelRestrictionTypeDifferent:
                                value?.IsLowerLevelRestrictionTypeDifferent,
                        })}
                    >
                        <div className="text">
                            {restrictionTypesValues[value?.RestrictionTypeId]?.value}
                        </div>
                    </div>
                ) : (
                    restrictionTypesValues[value?.RestrictionTypeId]?.value
                )}
            </Label>
        );
    };

    const ConflictingRestrictionMarker = ({ value, size, ...rest }) => {
        return <Popup
            content={value}
            trigger={
                <Icon
                    name="warning circle"
                    size={size || "small"}
                    {...rest}
                />
            }
        />
    }

    const liveDataFormatter = ({ value, row }) => {
        const showAllocations = () =>
            showAllocationsData && !_.isNil(value.AllocatedRooms);
        const restrictionType = restrictionTypesValues[value?.RestrictionTypeId] ?? {};

        const productFormatters = {
            // Per Room
            1: (
                <Segment
                    key="Product-PerRoom"
                    size="mini"
                    style={{ paddingTop: "1em" }}
                    secondary
                >
                    {showAllocations() && <AllocationDataPopup value={value} />}
                    <Label
                        attached="top right"
                        corner
                        size="mini"
                        color={restrictionType.color}
                        style={{ fontWeight: "bold" }}
                    >
                        {restrictionType.value}
                    </Label>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            opacity: value.PartiallyPriced ? 0.2 : 1,
                        }}
                    >
                        <div style={{ flex: 1 }}>
                            <Input
                                defaultValue={value.DoublePrice}
                                readOnly
                                size="small"
                                labelPosition="right"
                                type="text"
                                placeholder={text("Room")}
                                disabled={value.PartiallyPriced}
                                fluid
                                className={cn({
                                    isManuallyUpdated:
                                        markManualUpdates && value.IsManualOrRMS === "M",
                                    isNotAllowedExternalUpdatePrice:
                                        markManualUpdates && value?.AllowExternalUpdate === false,
                                })}
                            >
                                <Label>R</Label>
                                <input />
                                <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
                            </Input>
                        </div>
                    </div>
                    {value.ConflictingRestrictionTypeCustomerNames.length !== 0 && (
                        <ConflictingRestrictionMarker size={"large"} value={value.ConflictingRestrictionTypeCustomerNames.join(", ")} />
                    )}
                </Segment>
            ),
            // Per Person
            2: (
                <Segment
                    key="Product-PerPerson"
                    size="mini"
                    style={{ paddingTop: "1em" }}
                    secondary
                >
                    {showAllocations() && <AllocationDataPopup value={value} />}
                    <Label
                        attached="top right"
                        corner
                        size="mini"
                        color={restrictionType.color}
                        style={{ fontWeight: "bold" }}
                    >
                        {restrictionType.value}
                    </Label>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            opacity: value.PartiallyPriced ? 0.2 : 1,
                        }}
                    >
                        {value.SinglePrice != null && <div style={{ flex: 1, paddingBottom: "1em" }}>
                            <Input
                                size="small"
                                labelPosition="right"
                                type="text"
                                placeholder={text("Single")}
                                fluid
                                readOnly
                                disabled={value.PartiallyPriced}
                                defaultValue={value.SinglePrice}
                                className={cn({
                                    isManuallyUpdated:
                                        markManualUpdates && value.IsManualOrRMS === "M",
                                    isNotAllowedExternalUpdatePrice:
                                        markManualUpdates && value?.AllowExternalUpdate === false,
                                })}
                            >
                                <Label>S</Label>
                                <input />
                                <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
                            </Input>
                        </div>}
                        {value.DoublePrice != null && <div style={{ flex: 1 }}>
                            <Input
                                size="small"
                                labelPosition="right"
                                type="text"
                                placeholder={text("Double")}
                                fluid
                                readOnly
                                disabled={value.PartiallyPriced}
                                defaultValue={value.DoublePrice}
                                className={cn({
                                    isManuallyUpdated:
                                        markManualUpdates && value.IsManualOrRMS === "M",
                                    isNotAllowedExternalUpdatePrice:
                                        markManualUpdates && value?.AllowExternalUpdate === false,
                                })}
                            >
                                <Label>D</Label>
                                <input />
                                <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
                            </Input>
                        </div>}
                    </div>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            marginTop: "1em",
                        }}
                    >
                        <div
                            style={{ flex: 0.5, position: "relative" }}
                            className={cn({
                                isManuallyUpdated:
                                    markManualUpdates &&
                                    value?.IsManualOrRMSRestrictionMinDays === "M",
                                isNotAllowedExternalUpdateRestriction:
                                    markManualUpdates &&
                                    value?.AllowExternalUpdateRestriction === false,
                            })}
                        >
                            {value.ConflictingMinDaysCustomerNames.length !== 0 && (
                                <ConflictingRestrictionMarker value={value.ConflictingMinDaysCustomerNames.join(", ")} />
                            )}
                            <Input
                                size="small"
                                placeholder={text("Min")}
                                fluid
                                readOnly
                                defaultValue={value?.MinDays}
                            />
                        </div>
                        <div style={{ width: 5 }}></div>
                        <div
                            style={{ flex: 0.5, position: "relative" }}
                            className={cn({
                                isManuallyUpdated:
                                    markManualUpdates &&
                                    value?.IsManualOrRMSRestrictionMaxDays === "M",
                                isNotAllowedExternalUpdateRestriction:
                                    markManualUpdates &&
                                    value?.AllowExternalUpdateRestriction === false,
                            })}
                        >
                            {value.ConflictingMaxDaysCustomerNames.length !== 0 && (
                                <ConflictingRestrictionMarker value={value.ConflictingMaxDaysCustomerNames.join(", ")} />
                            )}
                            <Input
                                size="small"
                                placeholder={text("Max")}
                                fluid
                                defaultValue={value?.MaxDays}
                                readOnly
                            />
                        </div>
                    </div>
                    {value.ConflictingRestrictionTypeCustomerNames.length !== 0 && (
                        <ConflictingRestrictionMarker size={"large"} value={value.ConflictingRestrictionTypeCustomerNames.join(", ")} />
                    )}
                </Segment>
            ),
            // Villa
            3: (
                <Segment
                    key="Product-Villa"
                    size="mini"
                    style={{ paddingTop: "1em" }}
                    secondary
                >
                    {showAllocations() && <AllocationDataPopup value={value} />}
                    <Label
                        attached="top right"
                        corner
                        size="mini"
                        color={restrictionType.color}
                        style={{ fontWeight: "bold" }}
                    >
                        {restrictionType.value}
                    </Label>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            opacity: value.PartiallyPriced ? 0.2 : 1,
                        }}
                    >
                        <div style={{ flex: 1, paddingBottom: "1em" }}>
                            <Label>
                                {text("Guests")}: {value.Guests}
                            </Label>
                        </div>
                        <div style={{ flex: 1 }}>
                            <Input
                                size="small"
                                labelPosition="right"
                                type="text"
                                placeholder={text("Villa")}
                                fluid
                                readOnly
                                disabled={value.PartiallyPriced}
                                defaultValue={value.DoublePrice}
                                className={cn({
                                    isManuallyUpdated:
                                        markManualUpdates && value.IsManualOrRMS === "M",
                                    isNotAllowedExternalUpdatePrice:
                                        markManualUpdates && value?.AllowExternalUpdate === false,
                                })}
                            >
                                <Label>V</Label>
                                <input />
                                <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
                            </Input>
                        </div>
                    </div>
                    {value.ConflictingRestrictionTypeCustomerNames.length !== 0 &&
                        !value.PartiallyPriced && (
                            <ConflictingRestrictionMarker
                                size={"large"}
                                value={value.ConflictingRestrictionTypeCustomerNames.join(", ")}
                            />
                        )}
                </Segment>
            ),
            // Per Combination
            4: (
                <Segment
                    key="Product-PerCombination"
                    size="mini"
                    style={{ paddingTop: "1em" }}
                    secondary
                >
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            opacity: value.PartiallyPriced ? 0.2 : 1,
                        }}
                    >
                        {value.SinglePrice != null && <div style={{ flex: 1, paddingBottom: "1em" }}>
                            <Input
                                size="small"
                                labelPosition="right"
                                type="text"
                                placeholder={text("Single")}
                                disabled={value.PartiallyPriced}
                                fluid
                                className={cn({
                                    isManuallyUpdated:
                                        markManualUpdates && value.IsManualOrRMS === "M",
                                    isNotAllowedExternalUpdatePrice:
                                        markManualUpdates && value?.AllowExternalUpdate === false,
                                })}
                            >
                                <Label>S</Label>
                                <input />
                                <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
                            </Input>
                        </div>}
                        {value.DoublePrice != null && <div style={{ flex: 1 }}>
                            <Input
                                size="small"
                                labelPosition="right"
                                type="text"
                                placeholder={text("Double")}
                                fluid
                                className={cn({
                                    isManuallyUpdated:
                                        markManualUpdates && value.IsManualOrRMS === "M",
                                    isNotAllowedExternalUpdatePrice:
                                        markManualUpdates && value?.AllowExternalUpdate === false,
                                })}
                            >
                                <Label>D</Label>
                                <input />
                                <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
                            </Input>
                        </div>}
                    </div>
                </Segment>
            ),
        };
        const formatters = [
            // Hotel
            <Segment
                key="Hotel"
                size="mini"
                style={{ paddingTop: "3.5em", paddingBottom: "3em" }}
                secondary
            >
                {value?.HotelLevelOverbooking != null ? (
                    <Popup
                        content={hotelOverbookingTooltip(value)}
                        trigger={getHotelAvailabilityLabel(value)}
                    />
                ) : (
                    getHotelAvailabilityLabel(value)
                )}
                {RestrictionTypeLabel(value)}
                {showPaxOccupancy && 
                <Popup 
                    content={text("CurrentOccupancy") + `: ${value.CurrentOccupancy} ${value.MaxOccupancy ? text("PaxOccupancy") + " "+ value.MaxOccupancy : ""}`}
                    trigger={
                        <div style={{ position: "absolute", top: "15%", left: "50%", transform: "translate(-50%)", color: value.MaxOccupancy && value.CurrentOccupancy >= value.MaxOccupancy ? "red" : ""}}>
                        {`P=${value.CurrentOccupancy}${value.MaxOccupancy ? "/" + value.MaxOccupancy : ""}`}
                        </div>
                    }/>
                }
                {value.ConflictingRestrictionTypeCustomerNames.length !== 0 && (
                    <ConflictingRestrictionMarker size={"large"} value={value.ConflictingRestrictionTypeCustomerNames.join(", ")} />
                )}
                <Label attached="bottom left" basic>
                    {(((value?.Sold || 0) / ((value?.Gross || 0) - (value?.Oos || 0) || 1)) * 100).toFixed(1)}%
                </Label>
                <div className="indications">
                    {value?.Notes != null && (
                        <Popup
                            content={value.Notes}
                            trigger={<Icon name="comment" size="small" />}
                        />
                    )}
                    {value?.EventName != null && (
                        <Popup
                            content={value?.EventName}
                            trigger={<Icon name="star" size="small" />}
                        />
                    )}
                </div>

                <Label attached="bottom right" basic>
                    Y={(value?.Yield || 0).toFixed(0)}
                </Label>
                <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                    <div
                        style={{ flex: 0.5, position: "relative" }}
                        className={cn({
                            isManuallyUpdated:
                                markManualUpdates &&
                                value?.IsManualOrRMSRestrictionMinDays === "M",
                            isLowerLevelMinDaysDifferent: value?.IsLowerLevelMinDaysDifferent,
                        })}
                    >
                        {value.ConflictingMinDaysCustomerNames.length !== 0 && (
                            <ConflictingRestrictionMarker value={value.ConflictingMinDaysCustomerNames.join(", ")} />
                        )}
                        <Popup
                            content={restrictionMinDaysTooltip(value)}
                            trigger={
                                <Input
                                    size="small"
                                    placeholder={text("Min")}
                                    fluid
                                    readOnly
                                    defaultValue={value?.MinDays}
                                    className={cn({
                                        isNotAllowedExternalUpdateRestriction:
                                            markManualUpdates &&
                                            value?.AllowExternalUpdateRestriction === false,
                                    })}
                                />
                            }
                        />
                    </div>
                    <div style={{ width: 5 }}></div>
                    <div
                        style={{ flex: 0.5, paddingBottom: "1em", position: "relative" }}
                        className={cn({
                            isManuallyUpdated:
                                markManualUpdates &&
                                value?.IsManualOrRMSRestrictionMaxDays === "M",
                            isLowerLevelMaxDaysDifferent: value?.IsLowerLevelMaxDaysDifferent,
                        })}
                    >
                        {value.ConflictingMaxDaysCustomerNames.length !== 0 && (
                            <ConflictingRestrictionMarker value={value.ConflictingMaxDaysCustomerNames.join(", ")} />
                        )}
                        <Popup
                            content={restrictionMaxDaysTooltip(value)}
                            trigger={
                                <Input
                                    size="small"
                                    placeholder={text("Max")}
                                    fluid
                                    defaultValue={value?.MaxDays}
                                    readOnly
                                    className={cn({
                                        isNotAllowedExternalUpdateRestriction:
                                            markManualUpdates &&
                                            value?.AllowExternalUpdateRestriction === false,
                                    })}
                                />
                            }
                        />
                    </div>
                </div>

            </Segment>,
            // Room type
            <Segment key="Roomtype" size="mini" style={{ paddingTop: "3.5em", paddingBottom: "1em" }} secondary>
                {value?.MaxOverbookedRoomQuantity != null || value?.AvailabilityConsideringOverbooking != null ?
                    <Popup content={roomTypeOverbookingTooltip(value)}
                        trigger={getRoomTypeAvailabilityLabel(value)} /> :
                    getRoomTypeAvailabilityLabel(value)}
                {RestrictionTypeLabel(value)}
                {showPaxOccupancy && 
                <Popup 
                    content={text("CurrentOccupancy") + `: ${value.CurrentOccupancy} ${value.MaxOccupancy ? text("PaxOccupancy") + " "+ value.MaxOccupancy : ""}`}
                    trigger={
                        <div style={{ position: "absolute", top: "15%", left: "50%", transform: "translate(-50%)", color: value.MaxOccupancy && value.CurrentOccupancy >= value.MaxOccupancy ? "red" : ""}}>
                        {`P=${value.CurrentOccupancy}${value.MaxOccupancy ? "/" + value.MaxOccupancy : ""}`}
                        </div>
                    }/>
                }
                {value.ConflictingRestrictionTypeCustomerNames.length !== 0 && (
                    <ConflictingRestrictionMarker size={"large"} value={value.ConflictingRestrictionTypeCustomerNames.join(", ")} />
                )}
                <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                    <div
                        style={{ flex: 0.5, position: "relative" }}
                        className={cn({
                            isManuallyUpdated:
                                markManualUpdates &&
                                value?.IsManualOrRMSRestrictionMinDays === "M",
                            isNotAllowedExternalUpdateRestriction:
                                markManualUpdates &&
                                value?.AllowExternalUpdateRestriction === false,
                            isLowerLevelMinDaysDifferent: value?.IsLowerLevelMinDaysDifferent,
                        })}
                    >
                        {value.ConflictingMinDaysCustomerNames.length !== 0 && (
                            <ConflictingRestrictionMarker value={value.ConflictingMinDaysCustomerNames.join(", ")} />
                        )}
                        <Popup
                            content={restrictionMinDaysTooltip(value)}
                            trigger={
                                <Input
                                    size="small"
                                    placeholder={text("Min")}
                                    fluid
                                    readOnly
                                    defaultValue={value?.MinDays}
                                />
                            }
                        />
                    </div>
                    <div style={{ width: 5 }}></div>
                    <div
                        style={{ flex: 0.5, position: "relative" }}
                        className={cn({
                            isManuallyUpdated:
                                markManualUpdates &&
                                value?.IsManualOrRMSRestrictionMaxDays === "M",
                            isNotAllowedExternalUpdateRestriction:
                                markManualUpdates &&
                                value?.AllowExternalUpdateRestriction === false,
                            isLowerLevelMaxDaysDifferent: value?.IsLowerLevelMaxDaysDifferent,
                        })}
                    >
                        {value.ConflictingMaxDaysCustomerNames.length !== 0 && (
                            <ConflictingRestrictionMarker value={value.ConflictingMaxDaysCustomerNames.join(", ")} />
                        )}
                        <Popup
                            content={restrictionMaxDaysTooltip(value)}
                            trigger={
                                <Input
                                    size="small"
                                    placeholder={text("Max")}
                                    fluid
                                    readOnly
                                    defaultValue={value?.MaxDays}
                                />
                            }
                        />
                    </div>
                </div>
            </Segment>,
            // Rate
            <Segment key="Rate" size="mini" style={{ paddingTop: "1em" }} secondary>
                {showAllocations() && <AllocationDataPopup value={value} />}
                {RestrictionTypeLabel(value)}

                {showAllocations() && value.ConflictingRestrictionTypeCustomerNames.length !== 0 && (
                    <ConflictingRestrictionMarker size={"large"} value={value.ConflictingRestrictionTypeCustomerNames.join(", ")} />
                )}
                <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                    <div
                        style={{ flex: 0.5, position: "relative" }}
                        className={cn({
                            isManuallyUpdated:
                                markManualUpdates &&
                                value?.IsManualOrRMSRestrictionMinDays === "M",
                            isNotAllowedExternalUpdateRestriction:
                                markManualUpdates &&
                                value?.AllowExternalUpdateRestriction === false,
                            isLowerLevelMinDaysDifferent: value?.IsLowerLevelMinDaysDifferent,
                        })}
                    >
                        {value.ConflictingMinDaysCustomerNames.length !== 0 && (
                            <ConflictingRestrictionMarker value={value.ConflictingMinDaysCustomerNames.join(", ")} />
                        )}
                        <Popup
                            content={restrictionMinDaysTooltip(value)}
                            trigger={
                                <Input
                                    size="small"
                                    placeholder={text("Min")}
                                    fluid
                                    readOnly
                                    defaultValue={value?.MinDays}
                                />
                            }
                        />
                    </div>
                    <div style={{ width: 5 }}></div>
                    <div
                        style={{ flex: 0.5, position: "relative" }}
                        className={cn({
                            isManuallyUpdated:
                                markManualUpdates &&
                                value?.IsManualOrRMSRestrictionMaxDays === "M",
                            isNotAllowedExternalUpdateRestriction:
                                markManualUpdates &&
                                value?.AllowExternalUpdateRestriction === false,
                            isLowerLevelMaxDaysDifferent: value?.IsLowerLevelMaxDaysDifferent,
                        })}
                    >
                        {value.ConflictingMaxDaysCustomerNames.length !== 0 && (
                            <ConflictingRestrictionMarker value={value.ConflictingMaxDaysCustomerNames.join(", ")} />
                        )}
                        <Popup
                            content={restrictionMaxDaysTooltip(value)}
                            trigger={
                                <Input
                                    size="small"
                                    placeholder={text("Max")}
                                    fluid
                                    readOnly
                                    defaultValue={value?.MaxDays}
                                />
                            }
                        />
                    </div>
                </div>
            </Segment>,
            // Product
            productFormatters[row.RateType],
        ];
        return formatters[row.Level];
    };

    const getHotelAvailabilityLabel = (value) => {
        const markManualUpdatesForOverbooking =
            markManualUpdates && value?.HotelLevelOverbooking != null;
        return (
            <Label
                color={
                    markManualUpdatesForOverbooking && value?.IsManualOrRMS === "M"
                        ? "grey"
                        : getColorBasedOnAvailabilityAndOB(value, true)
                }
                floating
                circular
                style={{ left: "1em" }}
            >
                <div
                    className={cn({
                        isNotAllowedExternalUpdateOverbooking:
                            markManualUpdatesForOverbooking &&
                            value?.AllowExternalUpdate === false,
                    })}
                >
                    {value?.Available || 0}{" "}
                    {value?.HotelLevelOverbooking != null &&
                        `/ +${value.HotelLevelOverbooking}`}
                </div>
            </Label>
        );
    };

    const getRoomTypeAvailabilityLabel = (value) => {
        const markManualUpdatesForOverbooking = markManualUpdates && value?.MaxOverbookedRoomQuantity != null;
        return <Label color={markManualUpdatesForOverbooking && value?.IsManualOrRMS === "M" ? 'grey' : getColorBasedOnAvailabilityAndOB(value, false)} floating circular style={{ left: "1em" }}>
            <div className={cn({
                "isNotAllowedExternalUpdateOverbooking": markManualUpdatesForOverbooking && value?.AllowExternalUpdate === false,
            })}
            >
                {value?.Available || 0} {value?.MaxOverbookedRoomQuantity != null && `/ +${value.MaxOverbookedRoomQuantity}`}
            </div>
        </Label>;
    }

    const updateProductPricing = (expandedRowIds, allVisible = false) => {
        const hotelIds = new Set();
        const roomtypeIds = new Set();
        const rateIds = new Set();

        for (const id of expandedRowIds) {
            const parts = id.split('-');

            if (parts.length >= 1) hotelIds.add(Number(parts[0]));
            if (parts.length >= 2) roomtypeIds.add(Number(parts[1]));
            if (parts.length >= 3) rateIds.add(Number(parts[2]));
        }
        const productIds = data.filter(product =>
            hotelIds.has(product.HotelId) &&
            roomtypeIds.has(product.RoomTypeId) &&
            rateIds.has(product.RateId) &&
            (allVisible || product.Priced == false)
        ).map(product => product.Id);

        // Retrieve prices for the affected products
        if (productIds.length > 0) {
            doSearch.current?.(null, {
                ProductIds: productIds,
                IncludePricing: true,
                PricingOnly: true,
                NoLoader: true,
            });
        }
    }

    const getColorBasedOnAvailabilityAndOB = (value, isHotelLevel) => {
        const obProp = isHotelLevel ? 'HotelLevelOverbooking' : 'MaxOverbookedRoomQuantity';
        const availabilityValue = (value?.Available ?? 0) + (value?.[obProp] ?? 0);

        if (!isHotelLevel && value?.AvailabilityConsideringOverbooking != null &&
            (value?.AvailabilityConsideringOverbooking ?? 0) < availabilityValue
        ) return 'orange'

        return availabilityValue > 0 ? 'teal' : availabilityValue < 0 ? 'red' : ''
    }

    const MenuSidebar = () => {
        return (
            <Button.Group vertical icon style={{ float: "left" }}>
                {menu.map((x, idx) => {
                    return (
                        <Popup
                            key={idx}
                            position="top right"
                            content={text(x.text)}
                            trigger={
                                <Button
                                    as={"a"}
                                    disabled={x.disabled}
                                    href={x.url}
                                    icon
                                    onClick={x.onclick}
                                >
                                    <Icon size="big" className={x.className} />
                                </Button>
                            }
                        />
                    );
                })}
            </Button.Group>
        );
    };

    const GetLastRestrictionWithProperty = (
        level,
        restrictions,
        property,
        targetCustomerId
    ) => {
        if (!restrictions || restrictions.length === 0) {
            return null;
        }

        if (targetCustomerId) {
            const restrctionsOfLevelWithProperty = restrictions.filter(
                (r) => r[property] !== undefined && LevelPredicate(level, r)
            );

            return getLastCustomerRestriction(
                restrctionsOfLevelWithProperty,
                targetCustomerId
            );
        } else {
            return restrictions?.find(
                (element) =>
                    (element.CustomerId === undefined || element.CustomerId === OverrideCustomerRestrictionsCustomerId) &&
                    element[property] !== undefined &&
                    LevelPredicate(level, element)
            );
        }
    };

    const GetLastRestriction = (level, restrictions, targetCustomerId) => {
        if (!restrictions || restrictions.length === 0) {
            return null;
        }

        if (targetCustomerId) {
            const restrctionsOfLevelWithProperty = restrictions.filter((r) =>
                LevelPredicate(level, r)
            );

            return getLastCustomerRestriction(
                restrctionsOfLevelWithProperty,
                targetCustomerId
            );
        } else {
            return restrictions?.find(
                (element) =>
                    element.CustomerId === undefined && LevelPredicate(level, element)
            );
        }
    };

    const LevelPredicate = (level, element) => {
        return (
            (level === LevelValues.Product && element.ProductId) ||
            (level >= LevelValues.Rate && element.RateId) ||
            (level >= LevelValues.RoomType &&
                element.RoomTypeId &&
                !element.RateId) ||
            (level >= LevelValues.Hotel &&
                !element.RateId &&
                !element.RoomTypeId &&
                !element.ProductId)
        );
    };

    /**
     * Sorts products with promotions in a hierarchical order:
     * 1. By number of elements (room nights)
     * 2. By base product ID (groups related products together)
     * 3. Base products before their promotions
     * 4. Promotions sorted by promotion ID
     *
     * @param {Object} a - First product to compare
     * @param {Object} b - Second product to compare
     * @returns {number} Sort order (-1, 0, or 1)
     */
    const sortProductsWithPromotions = (a, b) => {
        // First priority: Sort by number of elements (room nights)
        if (a.NumberOfElements !== b.NumberOfElements) {
            return a.NumberOfElements - b.NumberOfElements;
        }

        // Second priority: Group by base product ID
        // Products with the same base ID should be adjacent
        const aBaseId = a.BaseProductId || a.Id;
        const bBaseId = b.BaseProductId || b.Id;

        if (aBaseId !== bBaseId) {
            return aBaseId - bBaseId;
        }

        // Third priority: Within same base product group, base product comes first
        // Base products have no PromotionId (0), promotions have PromotionId (1)
        const aIsPromotion = a.PromotionId ? 1 : 0;
        const bIsPromotion = b.PromotionId ? 1 : 0;

        if (aIsPromotion !== bIsPromotion) {
            return aIsPromotion - bIsPromotion;
        }

        // Fourth priority: If both are promotions, sort by PromotionId
        return (a.PromotionId || 0) - (b.PromotionId || 0);
    };

    const adjustDatesAndRefetch = async (operation) => {
        const dateRange = {
            FromDate: moment(search.FromDate)[operation](days, "days").toDate(),
            ToDate: moment(search.ToDate)[operation](days, "days").toDate(),
        };
        doSearch.current?.(dateRange);
    };

    const fastBackwardsDates = () => adjustDatesAndRefetch("subtract");
    const fastForwardsDates = () => adjustDatesAndRefetch("add");

    const BuildTooltipForLevel = (level, title, first) => {
        let linkedChainAddonsTooltipContent;
        if (level == LevelValues.RoomType && first?.LinkedChainAddons?.length) {
            const isAddonAssignedToRoomType = (addonName) => {
                const addon = addons.find(a => a.Name === addonName);
                return addon?.RoomTypeAddons?.some(rta => rta.RoomTypeId === first.RoomTypeId);
            };

            const assignedAddons = first.LinkedChainAddons.filter(ca => isAddonAssignedToRoomType(ca));

            if (assignedAddons.length > 0) {
                linkedChainAddonsTooltipContent = (
                    <div>
                        {title} <br />
                        {text("ProductIncludesTheFollowingAddons")}
                        {assignedAddons.map((ca) => {
                            return <div key={ca}>{ca}</div>;
                        })}
                    </div>
                );
            }
        }

        let popupTrigger = (
            <div>
                {
                    <div className="tree-item-title">
                        {titles[level] ? `${titles[level]}: ${title}` : title}
                        {level === LevelValues.Product && first?.PromotionId && (
                            <Icon className="icon-price-tag" size="large" style={{ marginLeft: '5px' }} />
                        )}
                        <br />
                        {level === LevelValues.Rate
                            ? first?.IsProductPricingIncludesTax
                                ? "Inc. TAX"
                                : "Not Inc. TAX"
                            : ""}
                    </div>
                }
                <div style={{ fontSize: 25 }}>
                    {linkedChainAddonsTooltipContent ? "*" : ""}
                </div>
            </div>
        );

        return (
            <Popup
                trigger={popupTrigger}
                name="tooltip"
                content={linkedChainAddonsTooltipContent || title}
            />
        );
    };

    const gridColumns = [
        {
            name: "PreviousDates",
            title: (
                <LeftChevronButton
                    content={text("Previous")}
                    onClick={fastBackwardsDates}
                />
            ),
        },
        { name: "Selection", title: text("Level") },
        { name: "Date_0", title: date_x(0), formatter: liveDataFormatter },
        { name: "Date_1", title: date_x(1), formatter: liveDataFormatter },
        { name: "Date_2", title: date_x(2), formatter: liveDataFormatter },
        { name: "Date_3", title: date_x(3), formatter: liveDataFormatter },
        { name: "Date_4", title: date_x(4), formatter: liveDataFormatter },
        { name: "Date_5", title: date_x(5), formatter: liveDataFormatter },
        { name: "Date_6", title: date_x(6), formatter: liveDataFormatter },
        { name: "Date_7", title: date_x(7), formatter: liveDataFormatter },
        { name: "Date_8", title: date_x(8), formatter: liveDataFormatter },
        { name: "Date_9", title: date_x(9), formatter: liveDataFormatter },
        {
            name: "NextDates",
            title: (
                <RightChevronButton
                    content={text("Next")}
                    onClick={fastForwardsDates}
                />
            ),
        },
    ];

    const specificWidthColumns = {
        PreviousDates: 45,
        Selection: 300,
        NextDates: 45,
    };

    const columnExtensions = gridColumns.map(({ name }) => ({
        columnName: name,
        width: specificWidthColumns[name],
    }));

    const gridOptions = {
        search: {
            groupSize: 9,
            fields: [
                <Form.Field
                    width={3}
                    placeholder={text("All")}
                    multiple
                    clearable
                    control={HotelsDropDown}
                    data={hotels}
                    label={text("Hotels")}
                    key="HotelIds"
                />,
                <DatePicker
                    type="basic"
                    label={text("StartDate")}
                    name="FromDate"
                    key="FromDate"
                />,
                <Form.Field
                    width={3}
                    label={text("RoomTypes")}
                    key="RoomTypeIds"
                    placeholder={text("All")}
                    clearable
                    search
                    multiple
                    control={RoomTypesDropDown}
                    data={roomTypes}
                />,
                <Form.Field
                    width={3}
                    label={text("Customer")}
                    key="CustomerId"
                    placeholder={text("All")}
                    clearable
                    control={CustomerDropDown}
                    data={customers}
                    value={customerId}
                    onChange={setCustomerId}
                />,
                <Form.Field
                    width={3}
                    label={text("Rates")}
                    key="RateIds"
                    placeholder={text("All")}
                    multiple
                    clearable
                    search
                    control={RatesDropDown}
                    data={rates}
                />,
                <Form.Field
                    width={3}
                    label={text("Promotions")}
                    key="PromotionIds"
                    multiple
                    clearable
                    search
                    control={PromotionsDropDown}
                    data={promotions}
                />,
                ...(allocationFeatureEnabled
                    ? [
                        <Form.Field
                            label={text("Allocations")}
                            placeholder={text("All")}
                            key="AllocationIds"
                            multiple
                            clearable
                            search
                            control={AllocationsDropDown}
                            data={allocations}
                        />,
                    ]
                    : []),
                <Form.Field key='Empty1' />,
                <CheckboxWrapper
                    label={text("ConsiderOverbooking")}
                    key="ConsiderOverbooking"
                />,
                <CheckboxWrapper
                    label={text("MarkManualUpdates")}
                    key="MarkManualUpdates"
                    value={markManualUpdates}
                    onChange={(value) => setMarkManualUpdates(value)}
                />,
                <CheckboxWrapper
                    label={text("ShowPaxOccupancy")}
                    key="ShowPaxOccupancy"
                    value={showPaxOccupancy}
                    onChange={(value) => setShowPaxOccupancy(value)}
                />,
            ],
            initial: search,
            spec: {
                ...search,
                FromDate: moment(search.FromDate).toISOString(),
                ToDate: moment(search.ToDate).toISOString(),
            },
            api: Live.GetLiveData,
            setDoSearchRef: (ref) => (doSearch.current = ref),
            method: "POST",
        },
        grid: {
            columns: gridColumns,
            tree: {
                getChildRows: (row, rootRows) => {
                    const group = (level, rows, parentId) => {
                        const current = levels[level];
                        if (current) {
                            const levelId = levelIds[level];
                            if (level === LevelValues.Product) {
                                rows = _.orderBy(rows, current);
                                rows = rows.sort(sortProductsWithPromotions);
                            }
                            const grouped = _.groupBy(rows, item => `${item[levelId]}|${item[current]}`);
                            const result = _.map(grouped, (children, group) => {
                                const first = children[0];
                                const [id, title] = group.split("|");

                                let row = {
                                    Id: parentId ? `${parentId}-${id}` : id,
                                    Selection: BuildTooltipForLevel(level, title, first),
                                    RateType: first?.RateType,
                                    IsVillaRate: first?.IsVillaRate,
                                    CurrencyId: first?.CurrencyId,
                                    Level: level,
                                    next: level + 1,
                                    children,
                                };

                                const GetRestrictionMinDays = (
                                    level,
                                    restrictions,
                                    targetCustomerId
                                ) => {
                                    const restrictionWithMinDays = GetLastRestrictionWithProperty(
                                        level,
                                        restrictions,
                                        "MinDays",
                                        targetCustomerId
                                    );
                                    if (restrictionWithMinDays) {
                                        return restrictionWithMinDays.MinDays;
                                    }

                                    if (
                                        (level === LevelValues.Product ||
                                            level === LevelValues.Rate) &&
                                        first.RateMinNights
                                    ) {
                                        return first.RateMinNights;
                                    }

                                    return 1;
                                };

                                const GetRestrictionMaxDays = (
                                    level,
                                    restrictions,
                                    targetCustomerId
                                ) => {
                                    const restrictionWithMaxDays = GetLastRestrictionWithProperty(
                                        level,
                                        restrictions,
                                        "MaxDays",
                                        targetCustomerId
                                    );
                                    if (restrictionWithMaxDays) {
                                        return restrictionWithMaxDays.MaxDays;
                                    }

                                    if (
                                        (level === LevelValues.Product ||
                                            level === LevelValues.Rate) &&
                                        first.RateMaxNights
                                    ) {
                                        return first.RateMaxNights;
                                    }

                                    return 99;
                                };

                                const GetConflictingCustomers = (
                                    level,
                                    restrictions,
                                    propertyName,
                                    propertyValue
                                ) => {
                                    if (!restrictions || restrictions.length === 0) {
                                        return [];
                                    }

                                    const customerIds = Object.keys(
                                        groupBy(restrictions, "CustomerId")
                                    )
                                        .map((id) => Number(id))
                                        .filter((id) => id !== 1);

                                    const result = [];
                                    customerIds.forEach((id) => {
                                        const lastRestriction = GetLastRestrictionWithProperty(
                                            level,
                                            restrictions,
                                            propertyName,
                                            id
                                        );
                                        if (
                                            lastRestriction &&
                                            lastRestriction.CustomerId === id &&
                                            lastRestriction[propertyName] !== propertyValue
                                        ) {
                                            result.push(id);
                                        }
                                    });

                                    return result.map(
                                        (id) => customers.find((c) => c.Id === id)?.Name
                                    );
                                };

                                for (let i = 0; i < days; i++) {
                                    const targetCustomerId = first?.Dates[i].CustomerId;
                                    const allRestrictions = first?.Dates[i].Restrictions;
                                    const conflictingRestrictions =
                                        first?.Dates[i].ConflictingRestrictions;
                                    const restriction = GetLastRestriction(
                                        level,
                                        allRestrictions,
                                        targetCustomerId
                                    );
                                    const restrictionType =
                                        GetLastRestrictionWithProperty(
                                            level,
                                            allRestrictions,
                                            "RestrictionTypeId",
                                            targetCustomerId
                                        )?.RestrictionTypeId ||
                                        RestrictionTypes.OpenRestrictionType;

                                    const restrictionWithMinDays = GetLastRestrictionWithProperty(
                                        level,
                                        allRestrictions,
                                        "MinDays",
                                        targetCustomerId
                                    );
                                    const minDays = GetRestrictionMinDays(
                                        level,
                                        allRestrictions,
                                        targetCustomerId
                                    );
                                    const restrictionWithMaxDays = GetLastRestrictionWithProperty(
                                        level,
                                        allRestrictions,
                                        "MaxDays",
                                        targetCustomerId
                                    );
                                    const maxDays = GetRestrictionMaxDays(
                                        level,
                                        allRestrictions,
                                        targetCustomerId
                                    );

                                    const conflictingRestrictionTypeCustomerNames =
                                        GetConflictingCustomers(
                                            level,
                                            conflictingRestrictions,
                                            "RestrictionTypeId",
                                            restrictionType
                                        );
                                    const conflictingMinDaysCustomerNames =
                                        GetConflictingCustomers(
                                            level,
                                            conflictingRestrictions,
                                            "MinDays",
                                            minDays
                                        );
                                    const conflictingMaxDaysCustomerNames =
                                        GetConflictingCustomers(
                                            level,
                                            conflictingRestrictions,
                                            "MaxDays",
                                            maxDays
                                        );
                                    const isLowerLevelHavingDifferentMinDays = (
                                        level,
                                        restrictions
                                    ) => {
                                        const lowerLevelMinDays = GetRestrictionMinDays(
                                            level,
                                            restrictions,
                                            targetCustomerId
                                        );
                                        return minDays !== lowerLevelMinDays;
                                    };

                                    const isLowerLevelHavingDifferentMaxDays = (
                                        level,
                                        restrictions
                                    ) => {
                                        const lowerLevelMaxDays = GetRestrictionMaxDays(
                                            level,
                                            restrictions,
                                            targetCustomerId
                                        );
                                        return maxDays !== lowerLevelMaxDays;
                                    };

                                    const isLowerLevelHavingDifferentRestrictionType = (
                                        level,
                                        restrictions
                                    ) => {
                                        const lowerLevelRestrictionType =
                                            GetLastRestrictionWithProperty(
                                                level,
                                                restrictions,
                                                "RestrictionTypeId",
                                                targetCustomerId
                                            );
                                        return (
                                            restrictionType !==
                                            (lowerLevelRestrictionType?.RestrictionTypeId ||
                                                RestrictionTypes.OpenRestrictionType)
                                        );
                                    };

                                    switch (level) {
                                        case LevelValues.Hotel:
                                            {
                                                var groupedByRoomType = _.map(
                                                    _.groupBy(children, "RoomTypeName"),
                                                    (rows) => {
                                                        return rows[0];
                                                    }
                                                );

                                                const isLowerLevelRestrictionTypeDifferent =
                                                    children.some(
                                                        (product) =>
                                                            isLowerLevelHavingDifferentRestrictionType(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ) ||
                                                            isLowerLevelHavingDifferentRestrictionType(
                                                                LevelValues.Rate,
                                                                product?.Dates[i].Restrictions
                                                            ) ||
                                                            isLowerLevelHavingDifferentRestrictionType(
                                                                LevelValues.RoomType,
                                                                product?.Dates[i].Restrictions
                                                            )
                                                    );

                                                const isLowerLevelMinDaysDifferent = children.some(
                                                    (product) =>
                                                        isLowerLevelHavingDifferentMinDays(
                                                            LevelValues.Product,
                                                            product?.Dates[i].Restrictions
                                                        ) ||
                                                        isLowerLevelHavingDifferentMinDays(
                                                            LevelValues.Rate,
                                                            product?.Dates[i].Restrictions
                                                        ) ||
                                                        isLowerLevelHavingDifferentMinDays(
                                                            LevelValues.RoomType,
                                                            product?.Dates[i].Restrictions
                                                        )
                                                );

                                                const isLowerLevelMaxDaysDifferent = children.some(
                                                    (product) =>
                                                        isLowerLevelHavingDifferentMaxDays(
                                                            LevelValues.Product,
                                                            product?.Dates[i].Restrictions
                                                        ) ||
                                                        isLowerLevelHavingDifferentMaxDays(
                                                            LevelValues.Rate,
                                                            product?.Dates[i].Restrictions
                                                        ) ||
                                                        isLowerLevelHavingDifferentMaxDays(
                                                            LevelValues.RoomType,
                                                            product?.Dates[i].Restrictions
                                                        )
                                                );

                                                let minMinDaysRestrictionTooltipValue = minDays;
                                                let maxMinDaysRestrictionTooltipValue = minDays;
                                                if (isLowerLevelMinDaysDifferent) {
                                                    children.forEach((product) => {
                                                        const allLevelMinDays = [
                                                            minDays,
                                                            GetRestrictionMinDays(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                            GetRestrictionMinDays(
                                                                LevelValues.Rate,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                            GetRestrictionMinDays(
                                                                LevelValues.RoomType,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                        ];

                                                        minMinDaysRestrictionTooltipValue = Math.min(
                                                            ...allLevelMinDays,
                                                            minMinDaysRestrictionTooltipValue
                                                        );
                                                        maxMinDaysRestrictionTooltipValue = Math.max(
                                                            ...allLevelMinDays,
                                                            maxMinDaysRestrictionTooltipValue
                                                        );
                                                    });
                                                }

                                                let minMaxDaysRestrictionTooltipValue = maxDays;
                                                let maxMaxDaysRestrictionTooltipValue = maxDays;
                                                if (isLowerLevelMaxDaysDifferent) {
                                                    children.forEach((product) => {
                                                        const allLevelMaxDays = [
                                                            maxDays,
                                                            GetRestrictionMaxDays(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                            GetRestrictionMaxDays(
                                                                LevelValues.Rate,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                            GetRestrictionMaxDays(
                                                                LevelValues.RoomType,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                        ];

                                                        minMaxDaysRestrictionTooltipValue = Math.min(
                                                            ...allLevelMaxDays,
                                                            minMaxDaysRestrictionTooltipValue
                                                        );
                                                        maxMaxDaysRestrictionTooltipValue = Math.max(
                                                            ...allLevelMaxDays,
                                                            maxMaxDaysRestrictionTooltipValue
                                                        );
                                                    });
                                                }

                                                const targetDate = moment(groupedByRoomType[0].Dates[i].Date)
                                                let currentAvailabilities = availabilityData.filter((a) => {
                                                    // Convert the date string from the availability data to a Date object
                                                    const availabilityDate = moment(a.Date);
                                                    // Compare the local date string representations
                                                    return targetDate.isSame(availabilityDate, "day") && a.HotelId === parseInt(row.Id);
                                                });
                                                row[`Date_${i}`] = {
                                                    Yield: first?.Dates[i].Yield || 0,
                                                    Gross: _.sumBy(
                                                        currentAvailabilities,
                                                        "GrossInventory"
                                                    ),
                                                    Oos: _.sumBy(currentAvailabilities, "Oos"),
                                                    Sold: _.sumBy(currentAvailabilities, "Sold"),
                                                    Available: _.sumBy(
                                                        currentAvailabilities,
                                                        "Available"
                                                    ),

                                                    HotelLevelOverbooking: currentAvailabilities.find(a => a.HotelLevelOverbooking != null)?.HotelLevelOverbooking,
                                                    IsManualOrRMS: currentAvailabilities.find(a => a.HotelLevelIsManualOrRMS != null)?.HotelLevelIsManualOrRMS,
                                                    AllowExternalUpdate: currentAvailabilities.find(a => a.HotelLevelAllowExternalUpdate != null)?.HotelLevelAllowExternalUpdate,

                                                    IsManualOrRMSRestrictionMinDays:
                                                        restrictionWithMinDays?.IsManualOrRMS,
                                                    IsManualOrRMSRestrictionMaxDays:
                                                        restrictionWithMaxDays?.IsManualOrRMS,
                                                    AllowExternalUpdateRestriction:
                                                        restriction?.AllowExternalUpdate,
                                                    RestrictionTypeId: restrictionType,
                                                    MinDays: minDays,
                                                    MaxDays: maxDays,

                                                    IsLowerLevelMinDaysDifferent:
                                                        isLowerLevelMinDaysDifferent,
                                                    IsLowerLevelMaxDaysDifferent:
                                                        isLowerLevelMaxDaysDifferent,
                                                    IsLowerLevelRestrictionTypeDifferent:
                                                        isLowerLevelRestrictionTypeDifferent,
                                                    MinMinDaysRestrictionTooltipValue:
                                                        minMinDaysRestrictionTooltipValue,
                                                    MaxMinDaysRestrictionTooltipValue:
                                                        maxMinDaysRestrictionTooltipValue,
                                                    MinMaxDaysRestrictionTooltipValue:
                                                        minMaxDaysRestrictionTooltipValue,
                                                    MaxMaxDaysRestrictionTooltipValue:
                                                        maxMaxDaysRestrictionTooltipValue,

                                                    ConflictingRestrictionTypeCustomerNames:
                                                        conflictingRestrictionTypeCustomerNames,
                                                    ConflictingMinDaysCustomerNames:
                                                        conflictingMinDaysCustomerNames,
                                                    ConflictingMaxDaysCustomerNames:
                                                        conflictingMaxDaysCustomerNames,

                                                    Notes: first?.Dates[i].Notes,
                                                    EventName: first?.Dates[i].EventName,
                                                    
                                                    // Hotel level pax occupancy (summed from all room types)
                                                    MaxOccupancy: _.sumBy(currentAvailabilities, "MaxOccupancy") || null,
                                                    CurrentOccupancy:
                                                        _.sumBy(currentAvailabilities, "Adults") +
                                                        _.sumBy(currentAvailabilities, "Children") +
                                                        _.sumBy(currentAvailabilities, "Infants"),
                                                };
                                            }
                                            break;
                                        case LevelValues.RoomType:
                                            {
                                                const isLowerLevelRestrictionTypeDifferent =
                                                    children.some(
                                                        (product) =>
                                                            isLowerLevelHavingDifferentRestrictionType(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ) ||
                                                            isLowerLevelHavingDifferentRestrictionType(
                                                                LevelValues.Rate,
                                                                product?.Dates[i].Restrictions
                                                            )
                                                    );

                                                const isLowerLevelMinDaysDifferent = children.some(
                                                    (product) =>
                                                        isLowerLevelHavingDifferentMinDays(
                                                            LevelValues.Product,
                                                            product?.Dates[i].Restrictions
                                                        ) ||
                                                        isLowerLevelHavingDifferentMinDays(
                                                            LevelValues.Rate,
                                                            product?.Dates[i].Restrictions
                                                        )
                                                );

                                                const isLowerLevelMaxDaysDifferent = children.some(
                                                    (product) =>
                                                        isLowerLevelHavingDifferentMaxDays(
                                                            LevelValues.Product,
                                                            product?.Dates[i].Restrictions
                                                        ) ||
                                                        isLowerLevelHavingDifferentMaxDays(
                                                            LevelValues.Rate,
                                                            product?.Dates[i].Restrictions
                                                        )
                                                );

                                                let minMinDaysRestrictionTooltipValue = minDays;
                                                let maxMinDaysRestrictionTooltipValue = minDays;
                                                if (isLowerLevelMinDaysDifferent) {
                                                    children.forEach((product) => {
                                                        const allLevelMinDays = [
                                                            minDays,
                                                            GetRestrictionMinDays(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                            GetRestrictionMinDays(
                                                                LevelValues.Rate,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                        ];

                                                        minMinDaysRestrictionTooltipValue = Math.min(
                                                            ...allLevelMinDays,
                                                            minMinDaysRestrictionTooltipValue
                                                        );
                                                        maxMinDaysRestrictionTooltipValue = Math.max(
                                                            ...allLevelMinDays,
                                                            maxMinDaysRestrictionTooltipValue
                                                        );
                                                    });
                                                }

                                                let minMaxDaysRestrictionTooltipValue = maxDays;
                                                let maxMaxDaysRestrictionTooltipValue = maxDays;
                                                if (isLowerLevelMaxDaysDifferent) {
                                                    children.forEach((product) => {
                                                        const allLevelMaxDays = [
                                                            maxDays,
                                                            GetRestrictionMaxDays(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                            GetRestrictionMaxDays(
                                                                LevelValues.Rate,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                        ];

                                                        minMaxDaysRestrictionTooltipValue = Math.min(
                                                            ...allLevelMaxDays,
                                                            minMaxDaysRestrictionTooltipValue
                                                        );
                                                        maxMaxDaysRestrictionTooltipValue = Math.max(
                                                            ...allLevelMaxDays,
                                                            maxMaxDaysRestrictionTooltipValue
                                                        );
                                                    });
                                                }

                                                let date = new Date(
                                                    first?.Dates[i].Date
                                                ).toLocaleDateString();
                                                let currentAvailability = availabilityData.find(
                                                    (a) =>
                                                        a.HotelId === first?.HotelId &&
                                                        a.RoomTypeId === first?.RoomTypeId &&
                                                        new Date(a.Date).toLocaleDateString() === date
                                                );
                                                row[`Date_${i}`] = {
                                                    Yield: first?.Dates[i].Yield || 0,
                                                    Gross: currentAvailability?.GrossInventory || 0,
                                                    Oos: currentAvailability?.Oos || 0,
                                                    Sold: currentAvailability?.Sold || 0,
                                                    Available: currentAvailability?.Available || 0,
                                                    MaxOverbookedRoomQuantity: currentAvailability?.MaxOverbookedRoomQuantity,
                                                    AvailabilityConsideringOverbooking: currentAvailability?.AvailabilityConsideringOverbooking != null
                                                        ? currentAvailability?.AvailabilityConsideringOverbooking
                                                        : currentAvailability?.ActualAvailability,
                                                    IsManualOrRMS: currentAvailability?.IsManualOrRMS,
                                                    AllowExternalUpdate:
                                                        currentAvailability?.AllowExternalUpdate,

                                                    IsManualOrRMSRestrictionMinDays:
                                                        restrictionWithMinDays?.IsManualOrRMS,
                                                    IsManualOrRMSRestrictionMaxDays:
                                                        restrictionWithMaxDays?.IsManualOrRMS,
                                                    AllowExternalUpdateRestriction:
                                                        restriction?.AllowExternalUpdate,
                                                    RestrictionTypeId: restrictionType,
                                                    MinDays: minDays,
                                                    MaxDays: maxDays,

                                                    IsLowerLevelMinDaysDifferent:
                                                        isLowerLevelMinDaysDifferent,
                                                    IsLowerLevelMaxDaysDifferent:
                                                        isLowerLevelMaxDaysDifferent,
                                                    IsLowerLevelRestrictionTypeDifferent:
                                                        isLowerLevelRestrictionTypeDifferent,
                                                    MinMinDaysRestrictionTooltipValue:
                                                        minMinDaysRestrictionTooltipValue,
                                                    MaxMinDaysRestrictionTooltipValue:
                                                        maxMinDaysRestrictionTooltipValue,
                                                    MinMaxDaysRestrictionTooltipValue:
                                                        minMaxDaysRestrictionTooltipValue,
                                                    MaxMaxDaysRestrictionTooltipValue:
                                                        maxMaxDaysRestrictionTooltipValue,

                                                    ConflictingRestrictionTypeCustomerNames:
                                                        conflictingRestrictionTypeCustomerNames,
                                                    ConflictingMinDaysCustomerNames:
                                                        conflictingMinDaysCustomerNames,
                                                    MaxOccupancy:
                                                        currentAvailability?.MaxOccupancy,
                                                    CurrentOccupancy:
                                                        (currentAvailability?.Adults ?? 0) + (currentAvailability?.Children ?? 0) + (currentAvailability?.Infants ?? 0),
                                                    ConflictingMaxDaysCustomerNames:
                                                        conflictingMaxDaysCustomerNames,
                                                };
                                            }
                                            break;
                                        case LevelValues.Rate:
                                            {
                                                const isLowerLevelRestrictionTypeDifferent =
                                                    children.some((product) =>
                                                        isLowerLevelHavingDifferentRestrictionType(
                                                            LevelValues.Product,
                                                            product?.Dates[i].Restrictions
                                                        )
                                                    );

                                                const isLowerLevelMinDaysDifferent = children.some(
                                                    (product) =>
                                                        isLowerLevelHavingDifferentMinDays(
                                                            LevelValues.Product,
                                                            product?.Dates[i].Restrictions
                                                        )
                                                );

                                                const isLowerLevelMaxDaysDifferent = children.some(
                                                    (product) =>
                                                        isLowerLevelHavingDifferentMaxDays(
                                                            LevelValues.Product,
                                                            product?.Dates[i].Restrictions
                                                        )
                                                );

                                                let minMinDaysRestrictionTooltipValue = minDays;
                                                let maxMinDaysRestrictionTooltipValue = minDays;
                                                if (isLowerLevelMinDaysDifferent) {
                                                    children.forEach((product) => {
                                                        const allLevelMinDays = [
                                                            minDays,
                                                            GetRestrictionMinDays(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                        ];

                                                        minMinDaysRestrictionTooltipValue = Math.min(
                                                            ...allLevelMinDays,
                                                            minMinDaysRestrictionTooltipValue
                                                        );
                                                        maxMinDaysRestrictionTooltipValue = Math.max(
                                                            ...allLevelMinDays,
                                                            maxMinDaysRestrictionTooltipValue
                                                        );
                                                    });
                                                }

                                                let minMaxDaysRestrictionTooltipValue = maxDays;
                                                let maxMaxDaysRestrictionTooltipValue = maxDays;
                                                if (isLowerLevelMaxDaysDifferent) {
                                                    children.forEach((product) => {
                                                        const allLevelMaxDays = [
                                                            maxDays,
                                                            GetRestrictionMaxDays(
                                                                LevelValues.Product,
                                                                product?.Dates[i].Restrictions
                                                            ),
                                                        ];

                                                        minMaxDaysRestrictionTooltipValue = Math.min(
                                                            ...allLevelMaxDays,
                                                            minMaxDaysRestrictionTooltipValue
                                                        );
                                                        maxMaxDaysRestrictionTooltipValue = Math.max(
                                                            ...allLevelMaxDays,
                                                            maxMaxDaysRestrictionTooltipValue
                                                        );
                                                    });
                                                }

                                                // Rate-level allocations should only show base product allocation data, not promotion-specific allocations
                                                // Promotion products have their own allocation data displayed at the product level
                                                const firstWithoutPromotion = children.find(product => !product.PromotionId);

                                                row[`Date_${i}`] = {
                                                    AllocatedRooms:
                                                        firstWithoutPromotion?.Dates[i].Allocation?.AllocatedRooms,
                                                    UsedRooms: firstWithoutPromotion?.Dates[i].Allocation?.UsedRooms,
                                                    LeftRooms: firstWithoutPromotion?.Dates[i].Allocation?.LeftRooms,
                                                    PresentedForSale:
                                                        firstWithoutPromotion?.Dates[i].Allocation?.PresentedForSale,
                                                    ReleaseDays: firstWithoutPromotion?.Dates[i].Allocation?.ReleaseDays,
                                                    Date: firstWithoutPromotion?.Dates[i].Date,

                                                    IsManualOrRMSRestrictionMinDays:
                                                        restrictionWithMinDays?.IsManualOrRMS,
                                                    IsManualOrRMSRestrictionMaxDays:
                                                        restrictionWithMaxDays?.IsManualOrRMS,
                                                    AllowExternalUpdateRestriction:
                                                        restriction?.AllowExternalUpdate,
                                                    RestrictionTypeId: restrictionType,
                                                    MinDays: minDays,
                                                    MaxDays: maxDays,

                                                    IsLowerLevelMinDaysDifferent:
                                                        isLowerLevelMinDaysDifferent,
                                                    IsLowerLevelMaxDaysDifferent:
                                                        isLowerLevelMaxDaysDifferent,
                                                    IsLowerLevelRestrictionTypeDifferent:
                                                        isLowerLevelRestrictionTypeDifferent,
                                                    MinMinDaysRestrictionTooltipValue:
                                                        minMinDaysRestrictionTooltipValue,
                                                    MaxMinDaysRestrictionTooltipValue:
                                                        maxMinDaysRestrictionTooltipValue,
                                                    MinMaxDaysRestrictionTooltipValue:
                                                        minMaxDaysRestrictionTooltipValue,
                                                    MaxMaxDaysRestrictionTooltipValue:
                                                        maxMaxDaysRestrictionTooltipValue,

                                                    ConflictingRestrictionTypeCustomerNames:
                                                        conflictingRestrictionTypeCustomerNames,
                                                    ConflictingMinDaysCustomerNames:
                                                        conflictingMinDaysCustomerNames,
                                                    ConflictingMaxDaysCustomerNames:
                                                        conflictingMaxDaysCustomerNames,
                                                };
                                            }
                                            break;
                                        case LevelValues.Product:
                                            {
                                                // Add allocation data for products with promotionId
                                                const productAllocationData = first?.PromotionId ? {
                                                    AllocatedRooms: first?.Dates[i].Allocation?.AllocatedRooms,
                                                    UsedRooms: first?.Dates[i].Allocation?.UsedRooms,
                                                    LeftRooms: first?.Dates[i].Allocation?.LeftRooms,
                                                    PresentedForSale: first?.Dates[i].Allocation?.PresentedForSale,
                                                    ReleaseDays:  first?.Dates[i].Allocation?.ReleaseDays,
                                                    Date: first?.Dates[i].Date,
                                                } : {};

                                                row[`Date_${i}`] = {
                                                    DoublePrice: roundToPrecision(
                                                        first?.Dates[i].DoublePrice,
                                                        2
                                                    ),
                                                    SinglePrice: roundToPrecision(
                                                        first?.Dates[i].SinglePrice,
                                                        2
                                                    ),
                                                    RoomPrice: first?.Dates[i].RoomPrice,
                                                    Guests: first?.Dates[i].Guests,
                                                    PartiallyPriced: first?.Dates[i].PartiallyPriced,

                                                    IsManualOrRMS: first?.Dates[i].IsManualOrRMS,
                                                    AllowExternalUpdate:
                                                        first?.Dates[i].AllowExternalUpdate,

                                                    IsManualOrRMSRestrictionMinDays:
                                                        restrictionWithMinDays?.IsManualOrRMS,
                                                    IsManualOrRMSRestrictionMaxDays:
                                                        restrictionWithMaxDays?.IsManualOrRMS,
                                                    AllowExternalUpdateRestriction:
                                                        restriction?.AllowExternalUpdate,
                                                    RestrictionTypeId: restrictionType,
                                                    MinDays: minDays,
                                                    MaxDays: maxDays,

                                                    ConflictingRestrictionTypeCustomerNames:
                                                        conflictingRestrictionTypeCustomerNames,
                                                    ConflictingMinDaysCustomerNames:
                                                        conflictingMinDaysCustomerNames,
                                                    ConflictingMaxDaysCustomerNames:
                                                        conflictingMaxDaysCustomerNames,

                                                    ...productAllocationData,
                                                };
                                            }

                                            break;
                                    }
                                }
                                return row;
                            });
                            return result;
                        } else {
                            return null;
                        }
                    };
                    return group(row?.next || 0, row?.children || rootRows, row?.Id);
                },
                treeColumnName: "Selection",
                onExpandedRowIdsChange: (expandedRowIds) => {
                    setExpandedRowIds(expandedRowIds);
                    updateProductPricing(expandedRowIds);
                }
            },
            getRowId: (row) => row.Id,
            columnExtensions: columnExtensions,
            scrollbarX: isMobileOnly
        },
    };

    const hotelIdForPopup =
        search.HotelIds?.length === 1 ? search.HotelIds[0] : null;

    const handlePopupSave = (updated, updatetype) => {
        if (data && data.length > 0) {
            switch (updatetype) {
                case "pricing":
                    updateProductPricing(expandedRowIds, true);
                    break;
                case "yields":
                case "restrictionsRemove":
                case "restrictions":
                case "overbooking":
                default:
                    doSearch.current?.();
                    break;
            }
        }
    };

    return (
        <div
            className="live"
            style={{
                flex: 1,
                display: "flex",
                flexDirection: "row",
                overflowY: "auto",
            }}
        >
            <div style={{ marginRight: 8 }}>
                <MenuSidebar />
            </div>
            <div style={{ flex: 1, display: "flex", overflow: "auto" }}>
                <GridSearchTemplate
                    options={gridOptions}
                    data={data}
                    onSearchChange={onSearchChange}
                    onSearchComplete={onSearchComplete}
                />
                <AllocationDatesPopup
                    open={showDatesPopup}
                    onClose={() => setShowDatesPopup(false)}
                    onSave={() => handlePopupSave()}
                    hotelId={hotelIdForPopup}
                    isPerReservation={false}
                    initialDate={fromDate}
                />
            </div>
            {showYieldPopup && (
                <YieldPopup
                    open={showYieldPopup}
                    HotelID={hotelIdForPopup}
                    onClose={() => setShowYieldPopup(false)}
                    onSave={(updated) => handlePopupSave(updated, "yields")}
                    initialDate={fromDate}
                />
            )}
            {showRemoveManualRestrictionsPopup &&
                canRemoveRestrictions && (
                    <RemoveManualRestrictionsPopup
                        HotelID={hotelIdForPopup}
                        onClose={() => setShowRemoveManualRestrictionsPopup(false)}
                        open={showRemoveManualRestrictionsPopup}
                        onSave={(updated) => handlePopupSave(updated, "restrictionsRemove")}
                        initialDate={fromDate}
                    />
                )}
            {showRestrictionsPopup && (
                <RestrictionsPopup
                    HotelID={hotelIdForPopup}
                    onClose={() => setShowRestrictionsPopup(false)}
                    open={showRestrictionsPopup}
                    onSave={(updated) => handlePopupSave(updated, "restrictions")}
                    initialDate={fromDate}
                />
            )}
            {showPriceUpdatePopup && (
                <PriceUpdatePopup
                    HotelID={hotelIdForPopup}
                    onClose={() => setShowPriceUpdatePopup(false)}
                    open={showPriceUpdatePopup}
                    onSave={(updated) => handlePopupSave(updated, "pricing")}
                    initialDate={fromDate}
                />
            )}
            {showOverbookingPopup && (
                <OverbookingCreationPopup
                    HotelID={hotelIdForPopup}
                    onCancelChanges={() => setShowOverbookingPopup(false)}
                    open={showOverbookingPopup}
                    onSave={(updated) => handlePopupSave(updated, "overbooking")}
                    askBeforeClose={false}
                    initialDate={fromDate}
                />
            )}
        </div>
    );
};
